import HeSocket from 'clover/net/SocketLib/Socket'
import { SocketServerHost } from '../config'

let socketHost = `${SocketServerHost}`
const socket = new HeSocket(socketHost)

socket.on('connect', () => {
  cc.log('socket connected')
})

socket.on('connect-timeout', () => {})

socket.on('error', e => {
  cc.log('socket error', e)
})

socket.on('close', e => {
  cc.log('socket closed', e)
})

socket.on('reconnect', attempt => {
  cc.log('scokect reconnencted', attempt)
})

socket.on('reconnect_error', function() {
  cc.log('attempt to reconnect has failed')
})

socket.on('disconnect', () => {
  cc.log('socket disconnected')
})

export default socket
